import { gql } from "@apollo/client";

export const GET_ZIPCODE_MAP_BOUNDARY = gql`
    query GetZipcodeMapBoundary($zipcode: String!) {
        getZipcodeMapBoundary(zipcode: $zipcode) {
            zipcode
            geometryType
            boundary
        }
    }
`;

export interface ZipcodeMapBoundaryType {
    zipcode: string;
    geometryType: string;
    boundary: string;
}

export interface GetZipcodeMapBoundaryResponse {
    getZipcodeMapBoundary: ZipcodeMapBoundaryType[];
}
